/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'wifi': {
    width: 16,
    height: 16,
    viewBox: '0 0 22 15.552',
    data: '<path pid="0" d="M0 4.553l2 2a12.729 12.729 0 0 1 18 0l2-2a15.566 15.566 0 0 0-22 0zm8 8l3 3 3-3a4.237 4.237 0 0 0-6 0zm-4-4l2 2a7.074 7.074 0 0 1 10 0l2-2a9.91 9.91 0 0 0-14 0z" fill-rule="evenodd"/>'
  }
})
